// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3-R1D","large":"styles_large__JPxGA"};